<script setup>
defineProps({
  variant: {
    type: String,
    default: '',
  },
  percentage: {
    type: [Number, String],
    default: 0,
  },
  size: {
    type: String,
    default: '10',
  },
  rightRadius: {
    type: Boolean,
    default: false,
  },
})
</script>
<template>
  <div
    class="w-full bg-gray-200"
    :class="{
      'rounded-full': !rightRadius,
      'rounded-r-[10px]': rightRadius,
    }"
  >
    <div
      :class="{
        'rounded-full': !rightRadius,
        'rounded-l-[10px]': rightRadius,
        'bg-success-50': variant === 'pago',
        'bg-warning-50': variant === 'negociado',
        'bg-error-50': variant === 'atrasado',
        'bg-info-50': variant === 'em dia',
        'bg-secondary-50': variant === 'baixado',
        'bg-primary-50': variant === 'cancelado',
      }"
      :style="`width: ${percentage}%; height: ${size}px;`"
    />
  </div>
</template>
